import { render, staticRenderFns } from "./JciProgramPlansCreate.vue?vue&type=template&id=696ae274&scoped=true"
import script from "./JciProgramPlansCreate.vue?vue&type=script&lang=js"
export * from "./JciProgramPlansCreate.vue?vue&type=script&lang=js"
import style0 from "./JciProgramPlansCreate.vue?vue&type=style&index=0&id=696ae274&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696ae274",
  null
  
)

export default component.exports